const $ = require("jquery");
const css = require("js/css_constants");
const events = require("js/event_helper");
const cssModule = require("js/css_constants");
const keyModule = require("js/keyboard.js");
const ldcLinkContent = require("js/editor/ldc_link_content.js");
const alertModule = require("js/alert");

module.exports.isInactive = function (selector) {
    return !__isActive(selector);
};

module.exports.isActive = __isActive;

module.exports.Activator = function (selector, action) {
    return function (...actionArgs) {
        action.apply(this, actionArgs);

        $(selector).removeClass(css.disabled);
    };
};

module.exports.Deactivator = function (selector, action) {
    return async function (...actionArgs) {
        const result = await action.apply(this, actionArgs);
        $(selector).addClass(css.disabled);
        return result;
    };
};

module.exports.getLinkedCard = function (event) {
    return findLinkParent(event.target).attributes.links_to.value;
};

module.exports.isLinkedCardInaccessible = function (event) {
    return findLinkParent(event.target).dataset.inaccessible;
};

module.exports.addFollowLink = function (
    dispatcherFunction,
    link,
    closePopup = null,
    alwaysOpenInPartner = false,
    optsEnricherFunction = (opts) => opts,
) {
    const listenerToAdd = (event) => {
        if (closePopup) {
            closePopup();
        }

        let linkedId = module.exports.getLinkedCard(event);
        let isInaccessible = module.exports.isLinkedCardInaccessible(event);

        if (linkedId != null && isInaccessible == "true") {
            alertModule.danger(document, "This card is not accessible.");
            return;
        }

        // if internal link to another card
        if (linkedId != null) {
            event.preventDefault();
            event.stopPropagation();
            const openInPartner = alwaysOpenInPartner ? true : event.shiftKey;

            const opts = {
                openInPartner: openInPartner,
                inNewWindow: keyModule.ctrlMeta(event),
            };

            events.displayCard(dispatcherFunction(), linkedId, optsEnricherFunction(opts));
        }
    };
    link.addEventListener("click", listenerToAdd);
    return listenerToAdd;
};

module.exports.followInternalCardLinks = function (dispatcher, element, closePopup = null) {
    let links = element.querySelectorAll("ldc-card-relation, ldc-text-relation");

    links.forEach((link) => module.exports.addFollowLink(() => dispatcher, link));

    element.querySelectorAll("ldc-link-content").forEach((each) => {
        ldcLinkContent.addClickListener(each, dispatcher);
    });
};

module.exports.isCategory = function (card) {
    return card.type == "category";
};

function findLinkParent(node) {
    if (node == null) {
        return null;
    }

    if (node.nodeName === "LDC-TEXT-RELATION" || node.nodeName === "LDC-CARD-RELATION") {
        return node;
    } else {
        return findLinkParent(node.parentNode);
    }
}

function matchesAny(el, selectors) {
    for (let selector of selectors) {
        if (el.matches(selector)) return true;
    }
    return false;
}

function findParentWithSelector(el, selector, opts = {}) {
    let { stop, escapeShadowRoot } = opts;

    if (el == null) {
        return null;
    }

    while (el.nodeType != Node.ELEMENT_NODE) {
        el = el.parentNode;
    }

    const stopAt = stop ? stop : ["body"];

    if (el.matches(selector)) {
        return el;
    } else if (matchesAny(el, stopAt)) {
        return null;
    } else {
        if (el.parentElement == null && escapeShadowRoot) {
            let host = el;
            while (host != null && host.nodeType != Node.DOCUMENT_FRAGMENT_NODE) {
                host = host.parentNode;
            }

            if (host != null && host.nodeType == Node.DOCUMENT_FRAGMENT_NODE) {
                return findParentWithSelector(host.host, selector, opts);
            }
        }

        return findParentWithSelector(el.parentElement, selector, opts);
    }
}

module.exports.findParentWithSelector = findParentWithSelector;

module.exports.siblingsContain = function (node, sibling) {
    if (node == null || sibling == null) {
        return false;
    }

    if (node === sibling) {
        return true;
    }

    let iter = node;

    while (iter.previousSibling != null) {
        if (sibling === iter.previousSibling) {
            return true;
        }

        iter = iter.previousSibling;
    }

    iter = node;
    while (iter.nextSibling != null) {
        if (sibling === iter.nextSibling) {
            return true;
        }

        iter = iter.nextSibling;
    }

    return false;
};

module.exports.clamp = function (val, min, max) {
    return Math.min(Math.max(val, min), max);
};

module.exports.stringArraysEqual = function (a, b) {
    if (a.length != b.length) {
        return false;
    }

    function hasOne(val, arr) {
        return arr.some((other) => val.localeCompare(other) == 0);
    }

    return a.every((val) => hasOne(val, b));
};

module.exports.hbox = function (...children) {
    let box = document.createElement("div");
    box.classList.add("hbox");

    children.forEach((child) => box.appendChild(child));

    return box;
};

module.exports.button = function (text, primary = false) {
    const btn = document.createElement("button");
    btn.appendChild(document.createTextNode(text));
    btn.classList.add("btn");
    btn.classList.add(primary ? "btn-primary" : "btn-default");

    return btn;
};

module.exports.stretcher = function () {
    const stretch = document.createElement("div");
    stretch.classList.add("stretch");
    return stretch;
};

module.exports.objectsEqual = __objectsEqual;

module.exports.objectArrayEquals = function (a, b) {
    if (a === b) return true;

    if (a == null && b != null) return false;

    if (a != null && b == null) return false;

    if (a.length != b.length) return false;

    return a
        .map((oa) => {
            return b.find((ob) => __objectsEqual(oa, ob)) !== undefined;
        })
        .reduce((acc, found) => acc && found, true);
};

module.exports.isParentOfFocusedElement = function (parent) {
    return __isParentOfFocusedElement(parent, document.activeElement);
};

module.exports.eachSibling = function (element, fun) {
    let elem = element.parentNode.firstChild;
    do {
        if (elem.nodeType === 3) continue; // text node
        if (elem == element) continue; // skip the element
        fun(elem);
    } while ((elem = elem.nextSibling));
};

module.exports.removeAllChildren = function (element) {
    element.replaceChildren([]);
};

module.exports.objectEmpty = function (obj) {
    if (obj != null) {
        return Object.keys(obj).length === 0 && obj.constructor === Object;
    } else {
        return true;
    }
};

module.exports.isWindows = function () {
    return navigator.platform.toLowerCase().includes("win");
};

module.exports.boundingClientRelToBody = function (obj) {
    let rect = obj.getBoundingClientRect();
    // add window scroll position to get the offset position
    let left = rect.left + window.scrollX;
    let top = rect.top + window.scrollY;
    let right = rect.right + window.scrollX;
    let bottom = rect.bottom + window.scrollY;
    let x = rect.x + window.scrollX;
    let y = rect.y + window.scrollX;
    // width and height are the same
    let width = rect.width;
    let height = rect.height;
    return { left, top, right, bottom, x, y, width, height };
};

module.exports.getBoundingClientRectRelativeTo = function (element, relativeTo) {
    const to = relativeTo.getBoundingClientRect();
    const child = element.getBoundingClientRect();

    const adjusted = {};
    adjusted.top = child.top - to.top;
    adjusted.bottom = child.bottom - to.top;
    adjusted.left = child.left - to.left;
    adjusted.right = child.right - to.left;
    adjusted.x = child.x - to.x;
    adjusted.y = child.y - to.y;

    adjusted.width = child.width;
    adjusted.height = child.height;

    return adjusted;
};

module.exports.getBoundingClientRectRelativeToParent = function (element) {
    return module.exports.getBoundingClientRectRelativeTo(element, element.parentElement);
};

module.exports.parseBool = function (val, fallback = false) {
    if (val == null || typeof val != "string") {
        return fallback;
    } else {
        return val.trim().toLowerCase() == "true" ? true : false;
    }
};

module.exports.camelize = function (string) {
    if (typeof string === "string") {
        return string.replace(/_([a-z])/g, (_match, letter) => letter.toUpperCase());
    } else {
        throw new TypeError("Invalid type, can only camelize strings, but  got: " + string.toString());
    }
};

function __isParentOfFocusedElement(parent, element) {
    if (element === null) {
        return false;
    }

    if (element === parent) {
        return true;
    } else {
        return __isParentOfFocusedElement(parent, element.parentElement);
    }
}

function __objectsEqual(a, b) {
    if (a === b) return true;

    if (a == null && b != null) return false;

    if (a != null && b == null) return false;

    let keys_a = Object.keys(a);
    let keys_b = Object.keys(b);

    if (keys_a.length != keys_b.length) return false;

    return keys_a.reduce((acc, key) => {
        return acc && a[key] === b[key];
    }, true);
}

function __isActive(selector) {
    return !$(selector).hasClass(css.disabled);
}

// all this is a bit hacky and should not be necessary at all, but because of the interop with the old
// JS code we cannot avoid this:
//
// Most of our rewritten live components, and their containers, are rendered "disabled" by default. So
// everytime we now trigger a change and rerender on the server, the components will be disabled
// again. However we also have sometimes the problem that even hidden components can be rerendered
// (e.g. when adding a new tab).
//
// So in order to reset the status of the component to the correct value, and activate the parent
// container, we need this little hack to be called from the `mounted()` and `updated()` hooks.
//
// Note: The returned callback for the `updated()` hook is best stored in the element, however we do
// not do this in here directly so that you are free to store it somewhere else, and to make it
// explicit in the hooks.
module.exports.fixLiveEnabledStatus = function (element, parentSelector = []) {
    const STATUS_DISABLED = "disabled";
    const STATUS_ENABLED = "enabled";

    if (typeof parentSelector === "string") {
        parentSelector = [parentSelector];
    }

    function getEnabledStatus() {
        return element.classList.contains(cssModule.disabled) ? STATUS_DISABLED : STATUS_ENABLED;
    }

    // tracks the current status on updates from the live view server
    let enabledStatus = getEnabledStatus();

    // observer all classList mutations, and change the activationStatus for the container
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            enabledStatus = getEnabledStatus();
        });
    });

    observer.observe(element, { attributes: true, attributeFilter: ["class"] });

    return function (onEnabled) {
        if (enabledStatus == STATUS_ENABLED) {
            element.classList.remove(cssModule.disabled);

            parentSelector.forEach((selector) => {
                const parent = findParentWithSelector(element, selector);

                // could also not have a parent after all, so check again
                if (parent != null) {
                    parent.classList.remove(cssModule.disabled);
                }
            });

            onEnabled();
        }
    };
};

function getComponentIdentifier(element) {
    const info = findParentWithSelector(element, "*[data-component-identifier]", {
        stop: [".component-layout"],
        escapeShadowRoot: true,
    });

    return info == null ? null : info.dataset.componentIdentifier;
}

module.exports.getComponentIdentifier = getComponentIdentifier;

// hacky workaround for bug in liveview, see here for refrence
// https://github.com/phoenixframework/phoenix_live_view/issues/973
// remove if bug has been fixed by simply writing the name of the current horizon into
// the div of the editor_form.html container. NOTE: CHECK if we need to remove the
// phx-update=ignore there to get the change!
module.exports.getCurrentComponentHorizon = function (element) {
    const side = getComponentIdentifier(element);

    if (side == "left") {
        return document.querySelector("#main-spa-container").dataset.currentHorizonLeft;
    } else if (side == "right") {
        return document.querySelector("#main-spa-container").dataset.currentHorizonRight;
    } else if (side == null) {
        console.warn("Cannot determine current component horizon, falling back to null");
        return null;
    } else {
        throw new Error("Invalid value for bug fix side: " + container.dataset.bugFixSide);
    }
};

/**
 * Returns true or false.
 */
module.exports.intersects = function (r1, r2) {
    return !(r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top);
};

module.exports.fullyContains = function (outer, inner) {
    return (
        inner.right <= outer.right && inner.left >= outer.left && inner.top >= outer.top && inner.bottom <= outer.bottom
    );
};

module.exports.clamp = function (num, min, max) {
    return num <= min ? min : num >= max ? max : num;
};

module.exports.getScaleFactor = function (card) {
    let insideSubivew = card.classList.contains("subview-card");
    let [parentScaleX, parentScaleY] = [1, 1];

    const transform = getComputedStyle(card)["transform"];

    const getXY = /matrix\((-?\d*\.?\d+),\s*0,\s*0,\s*(-?\d*\.?\d+),\s*0,\s*0\)/;

    const match = transform.match(getXY);
    if (match != null) {
        const [_matrix, x, y] = transform.match(getXY);
        return [Number.parseFloat(x) * parentScaleX, Number.parseFloat(y) * parentScaleY];
    } else {
        return [1 * parentScaleX, 1 * parentScaleY];
    }
};

/**
 * Imagine you have a subview X with another subview B inside.
 * Now B contains another card D.
 * This function will ensure that we keep only "first-level" children.
 */
module.exports.removeGrandChildren = (cards) => {
    return cards.filter((first) => {
        // Check if the cards have any "inner" children
        return !cards
            .filter((second) => second !== first)
            .some((each) => module.exports.fullyContains(each.getBoundingClientRect(), first.getBoundingClientRect()));
    });
};

function stickyHeaderStorageKey(cardId) {
    return "sticky-header-" + cardId;
}

module.exports.toggleStickyHeader = (header, cardId) => {
    header.classList.toggle("sticky");
    header.classList.toggle("shadow-lg");

    if (header.classList.contains("sticky")) {
        window.localStorage.setItem(stickyHeaderStorageKey(cardId), true);
    } else {
        window.localStorage.removeItem(stickyHeaderStorageKey(cardId));
    }
};

module.exports.stickyHeaderFromLocalStorage = (header, cardId) => {
    const hasStickyHeader = window.localStorage.getItem(stickyHeaderStorageKey(cardId));

    if (hasStickyHeader === "true") {
        header.classList.add("sticky");
        header.classList.add("shadow-lg");
    } else {
        header.classList.remove("sticky");
        header.classList.remove("shadow-lg");
    }
};

// waits for the selector to be available and calls the function
// observedRoot: only changes inside this element are observed (defaults to the whole body)
module.exports.waitForElements = (functionReturnElements, expirationAfterSeconds = 60, observedRoot = document.body) =>
    new Promise((resolve, reject) => {
        // call functionReturnElements only once per check, as it can be expensive (e.g. checkVisibility)
        const initiallyFound = functionReturnElements();
        if (initiallyFound.length > 0) {
            return resolve(initiallyFound);
        }

        const observer = new MutationObserver((mutations) => {
            const found = functionReturnElements();
            if (found.length > 0) {
                observer.disconnect();
                resolve(found);
            }
        });

        observer.observe(observedRoot, {
            childList: true,
            subtree: true,
        });

        // We don't want to observe forever for the changes. This puts a hard-limit of 1minute
        setTimeout(() => {
            observer.disconnect();
            reject();
        }, expirationAfterSeconds * 1000);
    });

// root defaults to document, but callers that need to scope the search to a specific component
// (e.g. to avoid matching the same element in a partner view) can pass a root element.
module.exports.waitForVisibleElement = (selector, callBackWithFoundElement = null, root = document) => {
    // this is a performance optimization as we had issue with slower machines:
    // only observe the changes inside the root, so other parts of the page do not trigger the expensive check
    const observedRoot = root === document ? document.body : root;
    return module.exports
        .waitForElements(
            () => Array.from(root.querySelectorAll(selector)).filter((element) => element.checkVisibility()),
            60,
            observedRoot,
        )
        .then((found) => {
            // called only once (it used to be called on every check that found the element)
            if (callBackWithFoundElement) {
                callBackWithFoundElement(found[0]);
            }
            return found;
        });
};

module.exports.findVisibleElement = (selector) => {
    return Array.from(document.querySelectorAll(selector)).find((elem) => elem.checkVisibility()) || null;
};

function isVisibleInWindow(element) {
    const rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
}

/**
 * This was implemented to fix bug #1615:
 * - When we triggered highlightIfInViewPort then we would scroll the element into view and trigger the highlight
 * - in Firefox it turns out that a click or mouse-scroll would stop the scroll (and do nothing)
 * - this would work in Chrome.
 *
 *
 * This function adds an event which gets triggered when the scroll ended and checks if the element is visible.
 * If not it triggers the scroll again, unfortunately we have observer the second scroll again, so we do this recursively.
 *
 * The retriesLeft is just there to prevent an infinite loop.
 *
 */
function scrollUntilVisible(element, retriesLeft) {
    if (!isVisibleInWindow(element) && retriesLeft > 0) {
        // when the scroll end, we check if the element is in view - if not trigger scroll again
        document.addEventListener(
            "scrollend",
            () => {
                if (!isVisibleInWindow(element)) {
                    scrollUntilVisible(element, retriesLeft - 1);
                }
            },
            {
                capture: true,
                once: true,
            },
        );
    }
    element.scrollIntoView({ behavior: "smooth", block: "center" });
}

module.exports.highlightIfInViewPort = (highlightedElements) => {
    for (const highlightedElement of highlightedElements) {
        console.log("Highlight element found, scroll into view", highlightedElement);
        scrollUntilVisible(highlightedElement, 5);

        let highlighted = false;
        let stopKeepingHighlight = () => {};

        // we want to trigger the animation only when the element is in viewPort. Listen for HTML element changes
        let observer = new IntersectionObserver((entries, observer) => {
            let isInViewPort = entries[0].isIntersecting;
            if (highlighted) {
                // stop the highlight once the element is scrolled out of the view
                if (!isInViewPort) {
                    observer.disconnect();
                    stopKeepingHighlight();
                    // remove the highlight
                    highlightedElement.classList.remove("highlight-link");
                }
            } else if (isInViewPort) {
                highlighted = true;
                console.log("Found element", highlightedElement);

                // restart the animation if the highlight is already there, otherwise adding the class starts it
                if (highlightedElement.classList.contains("highlight-link")) {
                    highlightedElement.getAnimations().forEach((animation) => {
                        animation.currentTime = 0;
                        animation.play();
                    });
                } else {
                    highlightedElement.classList.add("highlight-link");
                }
                stopKeepingHighlight = keepHighlightAfterReRender(highlightedElement);
            }
        });
        observer.observe(highlightedElement);
    }
};

/**
 * A LiveView re-render can remove the class again. Instead of waiting a fixed time before adding it,
 * we add it back whenever it gets removed while highlighting.
 * @return a function to stop it (e.g. when outside view)
 */
function keepHighlightAfterReRender(highlightedElement) {
    const classObserver = new MutationObserver(() => {
        if (!highlightedElement.classList.contains("highlight-link")) {
            highlightedElement.classList.add("highlight-link");
        }
    });

    const stop = () => {
        classObserver.disconnect();
        highlightedElement.removeEventListener("animationend", onAnimationEnd);
    };

    // once the animation is over, a re-render can remove the class
    const onAnimationEnd = (event) => {
        if (event.target === highlightedElement) {
            stop();
        }
    };

    highlightedElement.addEventListener("animationend", onAnimationEnd);
    classObserver.observe(highlightedElement, {
        attributes: true,
        attributeFilter: ["class"],
    });

    return stop;
}

/**
 * From: https://stackoverflow.com/a/21696585
 */
module.exports.isElementHidden = (el) => {
    const style = window.getComputedStyle(el);
    return style.display === "none";
};

// We need to verify if the target url points to a pdf
// checking for the ending was not enough, so we have checked what the server provides
module.exports.isPdfUrl = async (url) => {
    try {
        const response = await fetch(url, { method: "HEAD" });
        const contentType = response.headers.get("content-type");
        return contentType && contentType.includes("application/pdf");
    } catch (error) {
        console.error("Error:", error);
        return false;
    }
};

/**
 * We used to call window.open() but it does not cover all cases and poses some security issues.
 * Use this function instead to open a link (given by user)
 */
module.exports.openLink = (linkUrl) => {
    let url = linkUrl.trim();

    // Block javascript execution (to prevent any XSS)
    if (url.toLowerCase().startsWith("javascript:")) {
        console.error("Security risk detected");
        return;
    }

    // Ensure absolute URL: we had issue where user tried with "reddit.com" and it opened
    // with "ld.cards/reddit.com"
    if (!/^https?:\/\//i.test(url)) {
        url = "https://" + url;
    }

    //  open and disconnect the opener for security
    const newTab = window.open(url, "_blank");
    if (newTab) {
        // Prevents Tabnabbing (the opening url can modify the current page)
        newTab.opener = null;
    } else {
        alert("Your does not allow opening links, please allow pop-ups for this site.");
    }
};

/**
 * Returns the HTML of the current selection.
 * This function is written not by human.
 */
module.exports.getSelectionHtml = function (selection) {
    // nothing selected
    if (selection.rangeCount === 0) {
        return "";
    }

    const range = selection.getRangeAt(0);
    const container = document.createElement("div");
    container.appendChild(range.cloneContents());

    // Range.cloneContents() has a DOM-spec quirk: if the whole selection lies within
    // a single text node (e.g. selecting one word), it clones only the bare text and
    // drops any inline formatting element (like <strong>) wrapping it. So in that
    // case we walk up from the text node and re-wrap the clone in copies of each
    // ancestor that solely exists to decorate it (i.e. has no other children).
    if (range.startContainer === range.endContainer && range.startContainer.nodeType === Node.TEXT_NODE) {
        let ancestor = range.startContainer.parentElement;

        while (ancestor && ancestor.childNodes.length === 1 && getComputedStyle(ancestor).display.includes("inline")) {
            const wrapper = ancestor.cloneNode(false);
            while (container.firstChild) {
                wrapper.appendChild(container.firstChild);
            }
            container.appendChild(wrapper);

            ancestor = ancestor.parentElement;
        }
    }

    return container.innerHTML;
};

/**
 * Removes for given html any ldc-link-destination or ldc-link-content tags, keeping their
 * innerContent. Both tags contain an anchor-link id that must not be duplicated by copy-paste (as it would point
 * then to the wrong element)
 */
module.exports.removeLdcLinkDestination = function (html) {
    // temporary dom element
    const tmpDiv = document.createElement("div");
    tmpDiv.innerHTML = html;
    // remove all ldc-link-destination/ldc-link-content with their kids (the parents are being killed here :)
    tmpDiv.querySelectorAll("ldc-link-destination, ldc-link-content").forEach((el) => {
        el.replaceWith(...el.childNodes);
    });
    return tmpDiv.innerHTML;
};
